'use client'

import { ContentFilter } from '@/components/common/content-filter/content-filter'
import { SortOption } from '@/components/common/content-filter/use-content-filter'
import { ServiceCardRedesigned } from './service-card'

interface SerializedService {
  id?: string
  name: string
  slug: string
  description: string | null
  // The canonical category pick. A service can carry several categories now, but
  // this filter and the service card each render exactly one.
  primaryCategoryId: string | null
  categorySlug: string | null
  createdAt: string
  [key: string]: any
}

interface Category {
  name: string
  slug: string
}

interface Props {
  services: SerializedService[]
  categories: Category[]
  categoryMap: Record<string, string>
}

const sortOptions: SortOption<SerializedService>[] = [
  {
    label: 'Newest',
    value: 'newest',
    compareFn: (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  },
  {
    label: 'Oldest',
    value: 'oldest',
    compareFn: (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
  },
  {
    label: 'A–Z',
    value: 'az',
    compareFn: (a, b) => (a.name || '').localeCompare(b.name || ''),
  },
  {
    label: 'Z–A',
    value: 'za',
    compareFn: (a, b) => (b.name || '').localeCompare(a.name || ''),
  },
]

export function ServicesClient({ services, categories, categoryMap }: Props) {
  return (
    <ContentFilter
      items={services}
      categories={categories}
      sortOptions={sortOptions}
      searchFields={['name', 'description']}
      categoryAccessor={(s) => s.categorySlug}
      searchPlaceholder="Search services..."
      renderItems={(filtered) => (
        <section className="max-w-[1200px] mx-auto px-6 py-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((service) => (
              <ServiceCardRedesigned
                key={service.id}
                service={service as any}
                categoryName={service.primaryCategoryId ? categoryMap[service.primaryCategoryId] : undefined}
              />
            ))}
          </div>
        </section>
      )}
    />
  )
}
